import { Events } from '../constants/webSocketConsts/events';
import { Dispatch } from 'redux';
import { ensureUnreachable } from '../utils/common_utils';
import { paymentLinksApi, PaymentLink } from '../services/api/paymentLinksApi';

const updateCache = (
  event: Events,
  items: PaymentLink[],
  draft?: PaymentLink[],
) => {
  console.info('updateCache', { draft, event, items });
  const [paymentLinkObj] = items;

  if (!draft) {
    return;
  }

  const upcomingPaymentLinkIndex = draft.findIndex(
    (item: PaymentLink) => item.id === paymentLinkObj.id,
  );

  switch (event) {
    case Events.Insert: {
      if (upcomingPaymentLinkIndex !== -1) {
        return;
      }

      draft.unshift(paymentLinkObj);
      break;
    }
    case Events.Modify:
      if (upcomingPaymentLinkIndex === -1) {
        return;
      }
      draft.splice(
        0,
        draft.length,
        ...draft.map((item: PaymentLink) =>
          item.id === paymentLinkObj.id ? paymentLinkObj : item,
        ),
      );
      break;
    case Events.Remove:
      if (upcomingPaymentLinkIndex === -1) {
        return;
      }
      draft.splice(upcomingPaymentLinkIndex, 1);
      break;
    case Events.Refresh:
    case Events.DomainVerified:
      return;
    default:
      ensureUnreachable(event);
  }
};

export function handlePaymentLinkUpdate(
  event: Events,
  items: PaymentLink[],
  dispatch: Dispatch<any>,
) {
  const [item] = items;
  dispatch(
    paymentLinksApi.util.updateQueryData(
      'listPaymentLinks',
      undefined,
      (draft?: PaymentLink[]) => {
        updateCache(event, items, draft);
      },
    ),
  );
  dispatch(
    paymentLinksApi.util.updateQueryData(
      'getPaymentLink',
      item.id,
      (draft: PaymentLink) => {
        Object.assign(draft, item);
      },
    ),
  );
}
